import { Box } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { AutogiroMandateSentEnum } from 'src/shared/models/enums/autogiroMandateSent.enum';
import { AutogiroMandateResponse } from '../models/autogiroMandateResponse';

type AutogiroMandateSendStatusProps = {
  item: AutogiroMandateResponse;
};

export const AutogiroMandateSendStatus = (props: AutogiroMandateSendStatusProps) => {
  const { item } = props;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', '& .MuiChip-root': { borderRadius: 1 } }}>
      {item.sent === AutogiroMandateSentEnum.NotSent && <CheckCircle sx={{ color: (thm) => thm.palette.grey[200] }} fontSize='small' />}
      {item.sent === AutogiroMandateSentEnum.Sent && <CheckCircle sx={{ color: (thm) => thm.palette.success.dark }} fontSize='small' />}
    </Box>
  );
};
